import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { reduce } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import {
  USER_ADVANCED_EMAILS_HEADERS,
  USER_ADVANCED_HEADERS,
  USER_ADVANCED_QUIZ_HEADERS
} from "../../../../constants/table-custom-headers/User";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import KhattabatDataTable from "../../../../core/et3-table/KhattabatDataTable";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import {
  E_KHATTABAT_USER_ADVANCED_TABLE,
  TKhattabatUserAdvancedTable
} from "../../../../Types";

const KhattabatUserTables = withLiteObserverAndTheme(() => {
  const {
    currentUserId,
    userData,
    currentUserIsUnderCsrInvestigation,
    userAdvancedTableToShow,
    setUserAdvancedTableToShow,
    getUserDataRows
  } = getUserAdvancedStore();
  const data = userData.get(currentUserId.get());
  const { userIsUnderCsrInvestigation } =
    currentUserIsUnderCsrInvestigation.get();
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const shouldBeFlaggedTable =
    userIsUnderCsrInvestigation && !isAnyKhattabaAdmin;
  const tableToShow = userAdvancedTableToShow.get();
  const shouldShowUserData =
    tableToShow === E_KHATTABAT_USER_ADVANCED_TABLE.USER_DATA;

  const userDataRows = getUserDataRows();

  return (
    <Stack spacing={3}>
      {isAnyKhattabaAdmin ? (
        <ToggleButtonGroup
          exclusive
          size="small"
          color="primary"
          value={tableToShow}
          onChange={(_, value: TKhattabatUserAdvancedTable) => {
            if (value) {
              setUserAdvancedTableToShow(value);
            }
          }}
          sx={{ alignSelf: "flex-start" }}
        >
          <ToggleButton value={E_KHATTABAT_USER_ADVANCED_TABLE.USER_DATA}>
            {i18n.get("USER_DATA")}
          </ToggleButton>
          <ToggleButton value={E_KHATTABAT_USER_ADVANCED_TABLE.USER_PROFILE}>
            {i18n.get("USER_QUIZ")}
          </ToggleButton>
        </ToggleButtonGroup>
      ) : null}
      {shouldShowUserData ? (
        <KhattabatDataTable
          columns={USER_ADVANCED_HEADERS}
          title={i18n.get("USER_ADVANCED_TABLE")}
          rows={userDataRows}
          shouldBeFlagged={shouldBeFlaggedTable}
          titleKey={"USER_ADVANCED_TABLE"}
        />
      ) : (
        <KhattabatDataTable
          columns={USER_ADVANCED_QUIZ_HEADERS}
          title={i18n.get("USER_ADVANCED_QUIZ_TABLE")}
          rows={reduce(() => data.quizData, [])}
          shouldBeFlagged={shouldBeFlaggedTable}
          titleKey={"USER_ADVANCED_QUIZ_TABLE"}
        />
      )}
      <KhattabatDataTable
        columns={USER_ADVANCED_EMAILS_HEADERS}
        title={i18n.get("USER_ADVANCED_EMAIL_TABLE")}
        rows={reduce(() => data.emails, [])}
        shouldBeFlagged={shouldBeFlaggedTable}
        titleKey={"EMAILS"}
      />
    </Stack>
  );
});

export default KhattabatUserTables;
